import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import { getAllCars } from '../../services/carService';

class Admin extends React.Component {
    state = {
        cars: [],
    }
    componentDidMount = async () => {
        const { data: cars } = await getAllCars();
        console.log(cars);
        this.setState({ cars });
    }
    render() {
        return <div className="w-full">
            <nav class="relative bg-gray-900 py-8 px-4 flex items-center justify-between h-10 shadow-md" aria-label="Global">
                <div class="ml-4 pr-4 space-x-8">
                    <a href="/" class="font-medium text-gray-100 hover:text-gray-200 text-xl nav-font">Admin</a>
                </div>
            </nav>

            <div className="p-4">

                <Link to="/addCar">
                    <Button title="Add car" color="gray" iconName="plus" />
                </Link>

                <table class="border-collapse bg-gray-50 border mt-2 border-green-800 w-full">
                    <thead>
                        <tr>
                            <th className="border border-gray-200 px-2 py-2 w-10">#</th>
                            <th className="border border-gray-200 px-2 py-2">Name</th>
                            <th className="border border-gray-200 px-2 py-2 w-8"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.cars.map((car, index) =>
                                <tr className="">
                                    <td className="border border-gray-200 text-center">{index + 1}</td>
                                    <td className="border border-gray-200 px-2 py-2">{car.name}</td>
                                    <td className="border border-gray-200 px-2 py-2">
                                        <Link to={`/editCar/${car._id}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                            </svg>
                                        </Link>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>;
    }
}

export default Admin;